import { getRouteApi } from "@tanstack/react-router"
import { useStore } from "zustand"
import { createStore } from "zustand/vanilla"

type AbsenceMessage = {
  tone: "success" | "error"
  text: string
}

type AbsencesUiState = {
  startDate: string
  endDate: string
  reason: string

  message: AbsenceMessage | null

  setStartDate: (value: string) => void
  setEndDate: (value: string) => void
  setReason: (value: string) => void
  resetForm: () => void
  setMessage: (message: AbsenceMessage | null) => void
}

export const createAbsencesUiStore = () =>
  createStore<AbsencesUiState>((set) => ({
    startDate: "",
    endDate: "",
    reason: "",
    message: null,

    setStartDate: (value) => set({ startDate: value }),
    setEndDate: (value) => set({ endDate: value }),
    setReason: (value) => set({ reason: value }),
    resetForm: () => set({ startDate: "", endDate: "", reason: "" }),
    setMessage: (message) => set({ message }),
  }))

export type AbsencesUiStore = ReturnType<typeof createAbsencesUiStore>

export const useAbsencesStartDate = (store: AbsencesUiStore) =>
  useStore(store, (s) => s.startDate)

export const useAbsencesEndDate = (store: AbsencesUiStore) =>
  useStore(store, (s) => s.endDate)

export const useAbsencesReason = (store: AbsencesUiStore) =>
  useStore(store, (s) => s.reason)

export const useAbsencesMessage = (store: AbsencesUiStore) =>
  useStore(store, (s) => s.message)

const absencesRouteApi = getRouteApi("/_authed/absences")

export const useAbsencesRouteStore = () =>
  absencesRouteApi.useRouteContext({
    select: (ctx) => ctx.absencesStore,
  })
